import { useEffect, useRef, useSyncExternalStore } from "react";
import { useLocation } from "react-router";
import {
  applyAppUpdate,
  getAppUpdateState,
  isSafeToReloadPath,
  subscribeAppUpdate,
} from "utils/appUpdate";

// Hook untuk handle jika ada versi baru dari server (lihat utils/appUpdate).
const useAppUpdate = () => {
  const { updateAvailable, hasChatDraft } = useSyncExternalStore(
    subscribeAppUpdate,
    getAppUpdateState,
  );
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  // Pasang versi baru saat user pindah ke halaman aman. Isian di halaman sebelumnya
  // memang sudah ditinggalkan, jadi reload di sini tidak menambah data yang hilang.
  // Tidak reload saat:
  // - tujuan halaman form: sering dibuka membawa data dari halaman sebelumnya
  //   (mis. buat tiket dari chat), bisa hilang kalau di-reload
  // - kolom chat masih berisi draft: kolom chat tetap tampil saat pindah
  //   antar sub-halaman percakapan (list / search / ganti channel)
  useEffect(() => {
    if (prevPathnameRef.current === pathname) return;
    prevPathnameRef.current = pathname;

    if (
      updateAvailable &&
      isSafeToReloadPath(pathname) &&
      !getAppUpdateState().hasChatDraft
    ) {
      applyAppUpdate();
    }
  }, [pathname, updateAvailable]);

  return {
    updateAvailable,
    isSafeToReload: isSafeToReloadPath(pathname) && !hasChatDraft,
    pathname,
    onReloadPage: applyAppUpdate,
  };
};

export default useAppUpdate;
